import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

// PrimeNG 19 theming
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

// App declarations
import {
  AppComponent, HeaderComponent, FooterComponent, MainNavMenuComponent,
  LoadingIndicatorComponent, VersionComponent
} from './';
import { SpeedDialFabComponent } from './speed-dial-fab/speed-dial-fab.component';
import { SideNavListComponent } from './navigation/sidenav-list/sidenav-list.component';
import { SidenavVendorComponent } from './navigation/sidenav-list/sidenav-vendor/sidenav-vendor.component';
import { SidenavBuadminComponent } from './navigation/sidenav-list/sidenav-buadmin/sidenav-buadmin.component';
import { SidenavUserComponent } from './navigation/sidenav-list/sidenav-user/sidenav-user.component';

import { AppRoutingModule } from './app.routing.module';
import { AppMaterialModule } from './app.material.module';
import { ComponentsModule } from '#components/components.module';
import { ApiModule } from '#services/api/api.module';
import { SharedModule } from '#services/shared/shared.module';

// Interceptors (keep your app ones)
import { AuthInterceptor, DatetimeParseInterceptor, LoadingInterceptor, ErrorInterceptor } from '#services/interceptors';

// Services
import { LoadingIndicatorService, AuthService } from '#services/shared';
import { SpeedButtonService } from '#services/shared/speed-button.service';
import { GraphService } from '#services/shared/graph.service';

// ✅ CalAngular
import { CalAngularModule } from '@cvx/cal-angular';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainNavMenuComponent,
    LoadingIndicatorComponent,
    VersionComponent,
    SideNavListComponent,
    SidenavVendorComponent,
    SidenavBuadminComponent,
    SidenavUserComponent,
    SpeedDialFabComponent
  ],
  imports: [
    // Angular
    BrowserModule,              // provides CommonModule implicitly
    BrowserAnimationsModule,
    HttpClientModule,           // required to load assets/config.json
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ToastModule,
    RouterModule,
    AppRoutingModule,

    // Third‑party / Feature modules
    CalAngularModule.forRoot(environment.calConfigPath),   // ✅ add CAL here

    // App
    ComponentsModule,
    ApiModule,
    SharedModule
  ],
  providers: [
    // PrimeNG 19 configuration
    providePrimeNG({
      theme: {
        preset: Lara
      }
    }),
    MessageService,

    // ✅ Auth interceptor to add bearer tokens
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },

    // ✅ Keep your app interceptors
    { provide: HTTP_INTERCEPTORS, useClass: DatetimeParseInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // ✅ Keep app services
    GraphService,
    AuthService,
    LoadingIndicatorService,
    SpeedButtonService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }